<template>
  <div class="analytics-scene">
    <filter-panel />

    <widgets-panel />

    <recruiters-table />

    <vacancies-table />
  </div>
</template>

<script>
import FilterPanel from './filters/FilterPanel.vue';
import WidgetsPanel from './widgets/WidgetsPanel.vue';
import RecruitersTable from './recruiters/RecruitersTable.vue';
import VacanciesTable from './vacancies/VacanciesTable.vue';

import { ADMIN_ROLES, ROLE_COMPANY_ADMIN } from '@/_helpers/constants.js';

export default {
  components: {
    FilterPanel,
    WidgetsPanel,
    RecruitersTable,
    VacanciesTable
  },

  computed: {
    currentUser() {
      return this.$store.getters['user/current'];
    },

    metricsLoaded() {
      return this.$store.getters['services/metricsLoaded'];
    },

    is_admin() {
      if (!this.currentUser || !this.currentUser.roles || !this.currentUser.roles.length) {
        return false;
      }

      return ADMIN_ROLES.some(role => this.has_role(role)) || this.has_role(ROLE_COMPANY_ADMIN);
    }
  },

  watch: {
    metricsLoaded: {
      immediate: true,
      handler(val) {
        if (val && this.yandex_id && window[`yaCounter${this.yandex_id}`]) {
          window[`yaCounter${this.yandex_id}`].reachGoal('KPI_&_Analytics', {
            role: this.is_admin ? 'admin' : 'user'
          });
        }
      }
    }
  },

  methods: {
    has_role(needed) {
      return this.currentUser.roles.some(({ role }) => role === needed);
    }
  }
};
</script>
